/**
 * NP Productivity Timeline service.
 *
 * Translates camelCase UI payloads → snake_case repository payloads and wraps
 * everything in `IControllerPromiseResponse<T, { message }>` so callers get
 * uniform error handling.
 */

export const npProductivityTimelineServiceImplFactory = ({
  npProductivityTimelineRepository,
}: {
  npProductivityTimelineRepository: INpProductivityTimelineRepository;
}): INpProductivityTimelineService => {
  const toErr = (error: unknown) => ({
    message:
      (error as Error)?.message ?? "Unknown NP productivity timeline error",
  });

  const getTimeline: IGetNpTimelineService = async ({
    date,
    tz,
    includeRoster,
  }) => {
    try {
      const response = await npProductivityTimelineRepository.getTimeline({
        date,
        tz,
        include_full_roster: includeRoster,
      });
      return { success: true, data: response };
    } catch (error) {
      return { success: false, error: toErr(error) };
    }
  };

  const getWindowSummary: IGetNpWindowSummaryService = async ({
    start,
    end,
    tz,
    npIds,
  }) => {
    try {
      const response = await npProductivityTimelineRepository.getWindowSummary({
        start,
        end,
        tz,
        np_ids: npIds?.length ? npIds.join(",") : undefined,
      });
      return { success: true, data: response };
    } catch (error) {
      return { success: false, error: toErr(error) };
    }
  };

  return {
    getTimeline,
    getWindowSummary,
  };
};
